import { axios } from "~/plugins/request";
export const state = () => {
  return {
    messageCount: 0
  };
};
export const mutations = {
  SET_MESSAGE_COUNT: (state, data) => {
    state.messageCount = data;
  }
};
export const actions = {

  saveOrUpdateMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`notificationOnline/saveOrUpdateMessage`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectMessageInfoById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`notificationOnline/selectMessageInfoById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findOrgTreeByCurrentUser({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`notificationOnline/findOrgTreeByCurrentUser`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectMessageListPage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`notificationOnline/selectMessageListPage`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectSendMessageListPage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`notificationOnline/selectSendMessageListPage`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectReadDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`notificationOnline/selectReadDetail`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateReadStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`notificationOnline/updateReadStatus`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectNoReadMessageList({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`notificationOnline/selectNoReadMessageList`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectNoReadMessageCount({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`notificationOnline/selectNoReadMessageCount`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteOnlineNoticeMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`notificationOnline/deleteOnlineNoticeMessage`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectNoticeType({ commit }, params={}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`notificationOnline/selectNoticeType`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
